<template>
  <div>
	<send-proof-of-membership />
  </div>
</template>

<script>
(function(){
  // TODO: This is a bit of a hack. It works but 
  // should be replaced with code following the 
  // pattern.
  var div = document.getElementById("proof-of-membership");
  if (div !== null) {  
    var apiUrl = div.getAttribute("api-url");
    localStorage.setItem('pom-api-url', apiUrl);
  }
})();

import ProofOfMembershipService from '../proof-of-membership/services/ProofOfMembership.service.js';
import SendProofOfMembership from '../proof-of-membership/views/SendProofOfMembership.vue';

export default {
  name: 'ProofOfMembership',
	components: {
			SendProofOfMembership,
			ProofOfMembershipService
  },
  computed: {
    currentUser() {
      return this.$store.state.ProofOfMembership.user;
		},
  },
  methods: {
      persistUrl () {
        
      }
    }
};
</script>
